(function($) {

	var $win = $(window);
	var $doc = $(document);

	var opportunitiesFilters = [];
	var isBackButtonClicked = false;

	// Parallax
	$(window).on('scroll load', function() {
		var parallaxElement = $('.intro__background')
		var parallaxParent = parallaxElement.parent();
		var winST = $(window).scrollTop();

		$(parallaxElement).each(function() {
			if (parallaxParent.offset().top + parallaxParent.outerHeight() > winST) {
				$(this).css({
					'transform': 'translate3d(0,' + winST * -0.1 + 'px, 0)'
				})
			}
		})
	});

	$('.opportunity-categories-list li input').on( 'change', function(){
		var filters = [];
		var baseURL = window.location.href.split('?')[0];

		if ( $(this).val() === 'all' ) {
			filters = [];

			$('.opportunity-categories-list input:checked').each(function() {
				$(this).prop('checked', false);
			});
		} else {
			$('.opportunity-categories-list #all').prop('checked', false);
			$('.opportunity-categories-list input:checked').each(function() {
				filters.push($(this).val());
			});
		}

		if ( filters.length === 0 ) {
			$('.opportunity-categories-list #all').prop('checked', true);
		}

		if ( filters.length ) {
			var url = baseURL + '?filters=' + filters.join(',');
		} else {
			var url = baseURL;
		}

		var loadedUrl = $.grep( opportunitiesFilters, function(el) {
			return el.url == url;
		});

		if ( !isBackButtonClicked ) {
			history.pushState( null, null, url);
		}

		if ( loadedUrl.length ) {
			$('.tabs__content').html(loadedUrl[0].content);
		} else {
			$.ajax({
				url: url,
				type: 'GET',
				data: {
					filters: filters.join(','),
				},
				success: function(result) {
					var filteredContent = $(result).find('.tabs__content').html();
					$('.tabs__content').html(filteredContent);

					opportunitiesFilters.push({
						url: url,
						content: filteredContent
					});
				}
			});
		}

		isBackButtonClicked = false;
	});

	// Blog pagination
	$('.section-posts .posts-container').on( 'click', '.paging a', function(e){
		e.preventDefault();
		var url = $(this).attr('href');
		history.pushState( null, null, url);
		$.ajax({
			url: url,
			success: function(result) {
				var newContent = $(result).find('.section-posts .posts-container').html();
				$('.section-posts .posts-container').html(newContent);
				$('html,body').animate({
					scrollTop: $('.section-posts').offset().top - $('header').height() * 2
				}, 1000 );
				$('.section-posts .animate').addClass('animated');
			}
		})
	})

	$(document).on( 'click', '.opportunities-pagination a', function(e){
		e.preventDefault();
		var url = $(this).attr('href');

		$.ajax({
			url: url,
			type: 'GET',
			success: function(result) {
				var filteredContent = $(result).find('.tabs__content').html();
				$('.tabs__content').html(filteredContent);
				$('html,body').animate({
					scrollTop: $('.services').offset().top - $('header').height() * 2
				}, 1000 );
			}
		})
	});

	$(document).on('click', '.list-pills li', function(){
		$('.list-pills li').removeClass('active');
		var donateAmount = $(this).data('price');
		var donateFormlink =  $('.btn--donate').attr('href');
		$(this).addClass('active');

		// Add the selected amount to the URL of the donate form button.
		donateFormLink = updateQueryStringParameter( donateFormlink, 'amount', donateAmount );
		console.log(donateFormLink)
		$('.btn--donate').attr('href', donateFormLink );
	});

	$('.bar-message').on('click', '.btn-close', function(e){
		e.preventDefault();
		$('.bar-message').slideUp();
	})

	$(window).on('popstate', function(event) {
		isBackButtonClicked = true;
		var newUrl = location.href;
		if ( $('.section-posts .paging').length ) {
			$('.paging a[href="' + newUrl + '"]').click();
		} else {
			$('.opportunity-categories-list input[value="' + newUrl + '"]').attr('checked', 'checked').trigger('change');
		}
	});

	$('.no-link a').on( 'click', function(e) {
		e.preventDefault();
	});

	// Testimonial Slider
	$('.slider .slider__slides').slick({
		appendArrows: $('.slider .slider__actions')
	});

	// Nav Trigger
	$('.nav-trigger').on('click', function(e) {
		e.preventDefault();

		$(this).toggleClass('active');

		if($win.width() > 767) {
			$('.header').toggleClass('overlay');
			$('.nav').toggleClass('active');
		} else {
			$('.header .header__aside').toggleClass('active');
		}
	});

	if ( $('.popup').length && crb_options.popup_interval !== undefined ) {
		setTimeout( function() {
			$('.popup').addClass('visible');
		}, 1000 * crb_options.popup_interval )
	}

	// Popup close
	$('.popup .popup__btn').on('click', function(e) {
		e.preventDefault();
		$.ajax({
			url: crb_options.admin_ajax_url,
			data: {
				action: 'close_popup',
			}
		});
		$('.popup').removeClass('visible');
	});

	// Delay Transition
	function delayTransition($element, className, offset, delay) {
		if (!$element.length) {
			return;
		}

		for (var i = 0; i <= $element.length - 1; i++) {
			$element
				.eq(i)
					.css('transition-delay', '' + delay * i + 's');
		}

		$win.on('scroll load', function() {
			if ($win.scrollTop() + $win.outerHeight() > $element.offset().top + $element.outerHeight() - offset && $element.offset().top + $element.outerHeight() > $win.scrollTop()) {
				$element.addClass(className);
			}
		});
	};

	delayTransition($('.fade-bottom'), 'fade-in', 300, .2);
	delayTransition($('.fade-left'), 'fade-in', 200, .2);
	delayTransition($('.articles .fade-bottom'), 'fade-in', 200, .6);

	// Scroll Animations
	$win.on('load scroll', function() {
		animatedElements();

	});

	if ( $('#opportunity-map').length ) {
		initMap( $('#opportunity-map') );
	}

	function animatedElements() {
		var winST = $win.scrollTop();
		var winH  = $win.outerHeight();
		$('.animate').each(function() {
			var $this = $(this);
			var offset = $this.data('offset') || 300;

			if($win.width() <= 1024) {
				offset = 2000;
			}

			if ( $(this).data('mobile-offset') ) {
				offset = $(this).data('mobile-offset');
			}

			if (winST + $win.outerHeight() > $this.offset().top + $this.outerHeight() - offset && $this.offset().top + $this.outerHeight() > winST) {
				$this.addClass('animated');
			}	
		});
	}

	function initMap( mapElement ) {

		var lat = mapElement.data('lat');
		var lng = mapElement.data('lng');

		var mapCenter = {
			lat: lat,
			lng: lng
		};

        var map = new google.maps.Map(document.getElementById('opportunity-map'), {
          	zoom: 14,
          	center: mapCenter
        });
        var marker = new google.maps.Marker({
          	position: mapCenter,
          	map: map
        });
	}

	function updateQueryStringParameter( uri, key, value ) {
  		var re = new RegExp("([?&])" + key + "=.*?(&|#|$)", "i");
  		if (uri.match(re)) {
    		return uri.replace(re, '$1' + key + "=" + value + '$2');
  		} else {
    		var hash =  '';
    		if( uri.indexOf('#') !== -1 ) {
        		hash = uri.replace(/.*#/, '#');
        		uri = uri.replace(/#.*/, '');
    		}
    		var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    		return uri + separator + key + "=" + value + hash;
  		}
	}


})(jQuery);

